export default __webpack_public_path__ + "static/media/B55.ea964966.png";